module.exports = __webpack_public_path__ + "static/img/img3.dd2bcfd1.png";